import axios from 'axios'
import { uuidv4 } from '/@/utils/uuid'
import { CURRENT_CONFIG } from './config'
import { message } from 'ant-design-vue'
import router from '/@/router'
import { ELocalStorageKey, ERouterName, EUserType } from '/@/types/enums'
export * from './type'

const REQUEST_ID = 'X-Request-Id'
function getAuthToken () {
  return localStorage.getItem(ELocalStorageKey.Token)
}

const instance = axios.create({
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  // timeout: 12000,
})

instance.interceptors.request.use(
  config => {
    config.headers[ELocalStorageKey.Token] = getAuthToken()
    // config.headers[REQUEST_ID] = uuidv4()
    config.baseURL = CURRENT_CONFIG.baseURL
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

instance.interceptors.response.use(
  response => {
    // console.info('URL: ' + response.config.baseURL + response.config.url, '\nData: ', response.data, '\nResponse:', response)
    if (response.data.code && response.data.code !== 0) {
      if (response.data.message.includes('514303')) {
        // console.error(response.data.message)
        message.success('退出指令飞行成功')
      } else if (response.data.code === 200) {
        // message.success(response.data.message)
      } else {
        // 过滤掉 message 是 "failed" 的情况
        // {code:-1, message: 'failed'}
        if (response.data.message && response.data.message.toLowerCase() !== 'failed') {
          message.error(response.data.message)
        }
        console.log('错误信息:', response.data.message, '错误代码:', response.data.code)
      }
    }
    return response
  },
  err => {
    if (axios.isCancel(err)) {
      console.log('cancel request by user， 取消了')
    }
    const requestId = err?.config?.headers && err?.config?.headers[REQUEST_ID]
    if (requestId) {
      // console.info(REQUEST_ID, '：', requestId)
    }
    // console.info('url: ', err?.config?.url, `【${err?.config?.method}】 \n>>>> err: `, err)

    let description = '-'
    if (err.response?.data && err.response.data.message) {
      description = err.response.data.message
    }
    if (err.response?.data && err.response.data.result) {
      description = err.response.data.result.message
    }
    // @See: https://github.com/axios/axios/issues/383
    if (!err.response || !err.response.status) {
      // message.error('The network is abnormal, please check the backend service and try again')
      message.error('网络异常，请检查后端服务，然后重试！')
      return
    }
    if (err.response?.status !== 200) {
      console.error(`ERROR_CODE: ${err.response?.status}`)
    }
    // if (err.response?.status === 403) {
    //   // window.location.href = '/'
    // }
    if (err.response?.status === 401) {
      // console.error(err.response)
      const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag)) || EUserType.Web
      message.error('登录状态已过期，请重新登录！')
      switch (flag) {
        case EUserType.Web:
          router.push(ERouterName.LOGIN)
          break
        case EUserType.Pilot:
          router.push(ERouterName.PILOT)
          break
      }
    }

    return Promise.reject(err)
  },
)

export default instance
